export const getRatingFromReviews = (reviews: any) => {
  if (!reviews) {
    return 0;
  }
  const star5 = reviews.filter((obj: any) => obj.rating === 5).length;
  const star4 = reviews.filter((obj: any) => obj.rating === 4).length;
  const star3 = reviews.filter((obj: any) => obj.rating === 3).length;
  const star2 = reviews.filter((obj: any) => obj.rating === 2).length;
  const star1 = reviews.filter((obj: any) => obj.rating === 1).length;

  const rating = reviews.length > 0
    ? Number.parseFloat(
      Number.parseFloat(

        (5 * star5 + 4 * star4 + 3 * star3 + 2 * star2 + 1 * star1)
                / reviews.length,
      ).toFixed(1),
    )
    : 5;

  return rating;
};
